// src/components/profile/Bio.js
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import styles from '../../styles/pages/About.module.css';

/**
 * Shows bio content from markdown file
 * 
 * @param {Object} props - Component props
 * @param {string} [props.bioPath="/bio.md"] - Path to bio markdown file
 */
export function Bio({ bioPath = '/bio.md' }) {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    fetch(bioPath)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to fetch bio content: ${res.status}`);
        }
        return res.text();
      })
      .then((text) => {
        // Remove any HTML comments that might interfere with rendering
        const cleanedText = text.replace(/<!--[\s\S]*?-->/g, '');
        setContent(cleanedText);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Error loading markdown:', err);
        setError(err.message);
        setIsLoading(false);
      });
  }, [bioPath]);

  if (isLoading) {
    return <div className={styles.bioLoading}>Loading bio...</div>;
  }

  if (error) {
    return <div className={styles.bioError}>Unable to load bio content: {error}</div>;
  }

  // Custom components for markdown rendering
  const components = {
    h1: ({node, ...props}) => <h1 className={styles.bioHeading1} {...props} />
  };

  return (
    <div className={styles.bioContainer}>
      <div className={styles.bioContent}>
        <ReactMarkdown components={components} rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
      </div>
    </div>
  );
}